export default function(h) {
  let transform = 'rotate(0deg)'
  if (this.expanded) {
    transform = 'rotate(180deg)'
  }

  return h(
    'div',
    {
      class: `fjcc facc faic cursor--pointer square--${this.size}`,
      style: {
        transition: 'transform 150ms',
        transform
      },
      on: {
        click: () => {
          this.toggle()
        }
      }
    },
    [
      h(
        'g-icon',
        {
          props: {
            value: 'keyboard_arrow_down',
            color: 'grey'
          }
        }
      )
    ]
  )
}
